import React from "react";
import "./NotFound.css";

const GeoBlocked = () => (
  <div className="nf-root nf-403">
    <div className="nf-scrim" />
    <div className="nf-center">
      <div className="nf-card" role="status" aria-live="polite">
        <span className="nf-eyebrow">Not available</span>
        <div className="nf-rule" />
        <p className="nf-heading">This webcast isn't available in your region.</p>
        <p className="nf-body">
          The event organiser has limited where this webcast can be watched. Please contact them if
          you believe this is a mistake.
        </p>
      </div>
    </div>
  </div>
);

export default React.memo(GeoBlocked);
